import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'

export const CategoryPageHeaderContainer = styled.header<CmsProps>`
  min-height: 12.5rem;
  background-color: ${({ backgroundColour }) => backgroundColour ?? '#031126'};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    color: ${({ categoryTextColour }) => categoryTextColour ?? '#3A72C3'};
  }

  h2 {
    color: ${({ subCategoryTextColour }) => subCategoryTextColour ?? '#FFF'};
  }
`
